import React from 'react'

function Splash() {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      background: '#141F1A',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      zIndex: 9999,
    }}>
      <h1 style={{
        fontFamily: "'Lora', Georgia, serif",
        fontSize: '44px',
        fontWeight: '500',
        color: '#F0E8D5',
        letterSpacing: '-0.02em',
        margin: 0,
        animation: 'splashFade 0.4s ease forwards',
      }}>
        Kelionių
      </h1>
      <p style={{
        fontFamily: "'Syne', system-ui, sans-serif",
        fontSize: '13px',
        fontWeight: '500',
        color: '#7A8A7E',
        letterSpacing: '0.3em',
        textTransform: 'uppercase',
        margin: 0,
        animation: 'splashFade 0.4s ease 0.1s forwards',
        opacity: 0,
      }}>
        a p p
      </p>
      <div style={{
        width: '48px',
        height: '2px',
        background: '#E5A840',
        marginTop: '8px',
        animation: 'splashSweep 0.5s ease 0.2s forwards',
        transform: 'scaleX(0)',
        transformOrigin: 'left',
      }} />
      <style>{`
        @keyframes splashFade {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes splashSweep {
          from { transform: scaleX(0); }
          to   { transform: scaleX(1); }
        }
      `}</style>
    </div>
  )
}

export default Splash
